import AboutUsFA from './fa/fa.json'

const AboutUsMessages = {
  fa: { ...AboutUsFA },
}

export default AboutUsMessages
